<template>
  <div>
    <el-scrollbar style="height: 80vh">
      <div>转化效果图：</div>
      <div style="margin: 20px 0">
        <el-button size="mini">跟进时间</el-button>
        <el-date-picker
          v-model="dateTime"
          size="mini"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="~"
          :editable="false"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          clearable
          style="width: 240px; margin-right: 10px"
          :default-time="['00:00:00', '23:59:59']"
        >
        </el-date-picker>
      </div>

      <div style="display: flex">
        <div id="left" style="height: 400px; width: 30vw"></div>
        <div style="display: flex; flex-direction: column">
          <div style="display: flex; align-items: center">
            <div>上门转化率：</div>
            <div id="middle" style="height: 200px; width: 250px"></div>
          </div>
          <div style="display: flex; align-items: center">
            <div>成交转化率：</div>
            <div id="middle1" style="height: 200px; width: 250px"></div>
          </div>
        </div>
        <div class="right">
          <div class="item">说明：</div>
          <div class="item">线索：指触发了营销雷达从而产生线索的客户数量。</div>
          <div class="item">跟进：指跟进线索分配了跟进人的客户数量。</div>
          <div class="item">上门：指跟进后，最终上门的客户数量。</div>
          <div class="item">成交：指跟进后，最终成交的客户数量。</div>
        </div>
      </div>
      <div>员工明细表：</div>
      <div style="margin: 20px 0">
        <el-col :span="4">
          <el-input
            size="mini"
            suffix-icon="el-icon-search"
            placeholder="员工姓名"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="20">
          <el-button size="mini" style="margin-left: 10px">跟进时间</el-button>
          <el-date-picker
            v-model="dateTime"
            size="mini"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="~"
            :editable="false"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            clearable
            style="width: 240px; margin-right: 10px"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-col>
      </div>
      <div style="height: 50px"></div>
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ background: '#eef1f6' }"
      >
        <el-table-column prop="follower" label="员工姓名"> </el-table-column>
        <el-table-column prop="department" label="所属部门"> </el-table-column>
        <el-table-column prop="statusABCCount" label="跟进人数" sortable>
        </el-table-column>
        <el-table-column prop="statusABCount" label="上门人数" sortable>
        </el-table-column>
        <el-table-column prop="statusACount" label="成交人数" sortable>
        </el-table-column>
        <el-table-column prop="statusAAmount" label="成交金额" sortable>
        </el-table-column>
        <el-table-column prop="abratio" label="上门转化率" sortable>
        </el-table-column>
        <el-table-column prop="aratio" label="成交转化率" sortable>
        </el-table-column>
      </el-table>
    </el-scrollbar>
    <!-- <Pagination
      v-bind:childMsg="pageparm"
      :pageSizes="pageparm.pageSize"
      @callBack="callBack"
    ></Pagination> -->
  </div>
</template>

<script>
import { getChart, statisticsList } from "@/api/marketingRadar/index.js";
export default {
  created() {
    this.getCharts();
    this.getList();
  },
  data() {
    return {
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },
  methods: {
    getCharts() {
      getChart(
        {
          startTime: "",
          endTime: "",
        },
        localStorage.getItem("Authorization")
      ).then((res) => {
        let option = {
          xAxis: {
            type: "value",
            splitLine: false,
            show: false,
            boundaryGap: [0, 0.01],
          },
          color: ["#5087ec"],
          yAxis: {
            type: "category",
            data: res.data.xpos,
          },
          series: [
            {
              type: "bar",
              label: {
                show: true,
                position: "right",
              },
              data: res.data.ypos,
            },
          ],
        };

        let option1 = {
          color: ["#68bbc4", "#5087ec"],
          title: {
            text:
              res.data.abratio.length > 0
                ? (
                    (res.data.abratio[1].value / res.data.abratio[0].value) *
                    100
                  ).toFixed(2) + "%"
                : "0%",
            left: "center",
            top: "45%",
            textStyle: {
              // color:"#27D9C8",
              align: "center",
            },
          },
          series: [
            {
              type: "pie",
              radius: ["50%", "70%"],
              itemStyle: {
                borderRadius: 12,
                borderColor: "#fff",
                borderWidth: 1,
              },
              label: {
                normal: {
                  show: false,
                  position: "center",
                },
              },
              data: res.data.abratio,
            },
          ],
        };
        let option2 = {
          color: ["#68bbc4", "#5087ec"],
          title: {
            text:
              res.data.aratio.length > 0
                ? (
                    (res.data.aratio[1].value / res.data.aratio[0].value) *
                    100
                  ).toFixed(2) + "%"
                : "0%",
            left: "center",
            top: "45%",
            textStyle: {
              // color:"#27D9C8",
              align: "center",
            },
          },
          series: [
            {
              type: "pie",
              radius: ["50%", "70%"],
              itemStyle: {
                borderRadius: 12,
                borderColor: "#fff",
                borderWidth: 1,
              },
              label: {
                normal: {
                  show: false,
                  position: "center",
                },
              },
              data: res.data.aratio,
            },
          ],
        };
        this.setChart(option, "left");
        this.setChart(option1, "middle");
        this.setChart(option2, "middle1");
      });
    },
    getList() {
      statisticsList(
        {
          follower: "",
          startTime: "",
          endTime: "",
        },
        localStorage.getItem("Authorization")
      ).then((res) => {
        this.tableData = res.data;
        console.log("详细表", res);
      });
    },
    //分页回调
    callBack(parm) {
      // this.pageparm.pageNum = parm.currentPage;
      // this.pageparm.pageSize = parm.pageSize;
      this.getList();
    },
    setChart(option, type, index, color = ["#2478f2"]) {
      //#f39423
      let machart = this.$echarts.getInstanceByDom(
        document.getElementById(`${type}`)
      ); //有的话就获取已有echarts实例的DOM节点。
      if (machart == null) {
        // 如果不存在，就进行初始化。
        machart = this.$echarts.init(document.getElementById(`${type}`));
      }
      // 使用刚指定的配置项和数据显示图表。
      machart.setOption(option);
      // 根据页面大小自动响应图表大小
      window.addEventListener("resize", function() {
        machart.resize();
      });
    },
  },
  data() {
    return {
      dateTime: "",
      tableData: [],
    };
  },
};
</script>

<style lang="scss" scoped>
.right {
  padding: 50px 0 0 100px;

  .item {
    margin: 30px 0;
  }
}
</style>
